import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnichain = function SvgUnichain(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1288_4968)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip1_1288_4968)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_radial_1288_4968)",
        d: "M120.234 0h-120v120h120z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M110.008 59.053c-26.979 0-48.827-21.87-48.827-48.827h-1.893v48.827H10.46v1.894c26.979 0 48.827 21.87 48.827 48.827h1.893V60.947h48.827z"
    })))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1288_4968"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 120,
        height: 120,
        fill: "#fff",
        rx: 60
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip1_1288_4968"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 120.469,
        height: 120,
        fill: "#fff",
        rx: 60
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_1288_4968",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "matrix(0 60 -60 0 60.234 60)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FC74FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F50DB4"
    })))));
};

export { SvgUnichain as ReactComponent };
//# sourceMappingURL=Unichain.svg.es.js.map
